import EventLite from "event-lite";

class EventService extends EventLite {
  // No need for any implementation at this stage.
}

export const eventService = new EventService();
